/**
 * @desc 平台店铺-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlatformShopResponseDto>
>;
export function request(
  params: API.basics.platformShop.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformShop/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
